import { Typography } from "@mui/material";
import { Box } from "@mui/system";

const MapsInsightDefinition = ({ rowData }: any) => {
  const formatValue = (value: any) => {
    if (value === null || value === undefined) return "N/A";

    if (typeof value === "object") {
      return JSON.stringify(value, null, 2);
    }
    if (typeof value === "string") {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch {
        return value;
      }
    }

    return String(value);
  };

  return (
    <>
      <Box px={18} py={2}>
        <Typography textAlign={"left"} sx={{ color: "#000000DE" }}>
          <span style={{ color: "#00000099", fontSize: "14px" }}>
            Filtering Definition
          </span>
          <pre style={{ margin: "5px 0px" }}>
            {formatValue(rowData?.filtering_definition)}
          </pre>
        </Typography>

        <Typography textAlign={"left"} sx={{ color: "#000000DE" }}>
          <span style={{ color: "#00000099", fontSize: "14px" }}>
            Unique Definition
          </span>
          <pre style={{ margin: "5px 0px" }}>
            {formatValue(rowData?.unique_definition)}
          </pre>
        </Typography>
      </Box>
    </>
  );
};

export default MapsInsightDefinition;
